import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./contacts.css";

const contacts = () => {
  return (
    <div className="contacts">
      <div className="contactsInfo">
        MAX SCHMIDT LTDA<br />
        CNPJ 20.896.698/0001-82<br />
        <br />
        
        CONTATO<br />

        <div className="contactsInfoItem">
          <FontAwesomeIcon className='contactsPhoneIcon' icon={faWhatsapp} />
          (41) 99607-4017 / (41)  3338-4358
        </div>

        <div className="contactsInfoItem">
          <FontAwesomeIcon className='contactsInstagramItem' icon={faInstagram} />
          @maxsomambiente
        </div>

        <div className="contactsInfoItem">
          <FontAwesomeIcon className='contactsMailIcon' icon={faEnvelope} />
          maxsomambiente@gmail.com
        </div>
      </div>
    </div>
  );
};

export default contacts;
